import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { OnyxMascotFace } from "../../shared/OnyxMascot";

export function About() {
  return (
    <div className="min-h-screen bg-[#0a0a12]">
      <Header />
      <main className="pt-32 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <OnyxMascotFace size={40} />
            <h1 className="text-4xl font-bold text-white">About Onyx AI</h1>
          </div>

          <div className="space-y-8 text-[#b0a0c0] leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Our Mission</h2>
              <p>
                Onyx AI is built by <span className="text-[#c0a0e0]">Cloudforge Studio</span> to make
                intelligent customer support accessible to every business. We believe that great customer
                experience shouldn't require a large team or massive budget.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">What We Do</h2>
              <p>
                We provide an AI-powered chatbot platform that combines the best of automated responses
                with live agent support. Our platform handles FAQ matching, sentiment analysis, function
                calling, and seamless handoff to human agents — all in one embeddable widget.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Built for Southeast Asia</h2>
              <p>
                Based in Malaysia, we understand the unique needs of businesses in the region. Our
                platform supports multilingual conversations, local payment integrations, and is
                optimized for the way Southeast Asian businesses operate — from e-commerce sellers
                to clinics, restaurants, and service providers.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Our Technology</h2>
              <p>
                Onyx AI is powered by advanced large language models with custom fine-tuning for
                customer support scenarios. We combine AI intelligence with practical business tools
                like business hours management, canned responses, and real-time analytics to give
                you a complete support solution.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Contact Us</h2>
              <p>
                Have questions or want to learn more? Reach out to us at{" "}
                <a href="mailto:hello.onyx@cloudforge.com.my" className="text-[#c0a0e0] hover:underline">
                  hello.onyx@cloudforge.com.my
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
